import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export default class GetUserTakeoutLinkService extends Service {
  constructor({repository, service}) {
    super({repository, service})

    this._repository = repository
    this._service = service
  }

  /**
   * @return {Promise<ValueObject, Error>}
   */

  async execute({requestId, filename, useTranscendAPI = false}) {
    const userEntity = await this._service.execute()
    return this._repository.getUserTakeoutLink({
      requestId,
      filename,
      userEntity,
      useTranscendAPI
    })
  }
}
